import React, { createContext, useEffect, useState, useCallback } from 'react';

const PerformanceContext = createContext();

// export const PerformanceProvider = ({ children }) => {
//   const [isLowPerformance, setIsLowPerformance] = useState(false);
//   const [reducedMotion, setReducedMotion] = useState(false);
//   const [fps, setFps] = useState(60);
  
//   // Use refs to prevent dependency loops
//   const frameCountRef = useRef(0);
//   const lastTimeRef = useRef(performance.now());
//   const animationIdRef = useRef(null);
//   const lowPerfDetectedRef = useRef(false);

//   // Stabilize the animation config function with useCallback
//   const getAnimationConfig = useCallback((baseConfig = {}) => ({
//     ...baseConfig,
//     duration: reducedMotion ? 0.01 : isLowPerformance ? 0.2 : (baseConfig.duration || 0.3),
//     ease: reducedMotion ? 'linear' : (baseConfig.ease || [0.25, 0.46, 0.45, 0.94])
//   }), [reducedMotion, isLowPerformance]);

//   useEffect(() => {
//     // Check for reduced motion preference
//     const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
//     setReducedMotion(mediaQuery.matches);
    
//     const handleChange = () => setReducedMotion(mediaQuery.matches);
//     mediaQuery.addEventListener('change', handleChange);
    
//     return () => {
//       mediaQuery.removeEventListener('change', handleChange);
//     };
//   }, []); // Empty dependency array - only run once

//   useEffect(() => {
//     // Performance detection with throttled updates
//     const measurePerformance = (currentTime) => {
//       frameCountRef.current++;
      
//       // Only update FPS every second
//       if (currentTime - lastTimeRef.current >= 1000) {
//         const currentFPS = Math.round((frameCountRef.current * 1000) / (currentTime - lastTimeRef.current));
        
//         // Only update state if there's a significant change (reduces re-renders)
//         setFps(prevFps => {
//           if (Math.abs(prevFps - currentFPS) > 5) {
//             return currentFPS;
//           }
//           return prevFps;
//         });
        
//         // Set low performance flag only once when threshold is crossed
//         if (currentFPS < 45 && !lowPerfDetectedRef.current) {
//           lowPerfDetectedRef.current = true;
//           setIsLowPerformance(true);
//           console.warn('Low performance detected. Enabling performance mode.');
//         }
//         // Reset performance flag if FPS improves significantly
//         else if (currentFPS > 55 && lowPerfDetectedRef.current) {
//           lowPerfDetectedRef.current = false;
//           setIsLowPerformance(false);
//           console.log('Performance improved. Disabling performance mode.');
//         }
        
//         frameCountRef.current = 0;
//         lastTimeRef.current = currentTime;
//       }
      
//       animationIdRef.current = requestAnimationFrame(measurePerformance);
//     };
    
//     // Start monitoring after initial load
//     const timeoutId = setTimeout(() => {
//       animationIdRef.current = requestAnimationFrame(measurePerformance);
//     }, 2000);
    
//     return () => {
//       clearTimeout(timeoutId);
//       if (animationIdRef.current) {
//         cancelAnimationFrame(animationIdRef.current);
//       }
//     };
//   }, []); // Empty dependency array - only run once

//   // Memoize the context value to prevent unnecessary re-renders
//   const contextValue = React.useMemo(() => ({
//     isLowPerformance,
//     reducedMotion,
//     fps,
//     getAnimationConfig
//   }), [isLowPerformance, reducedMotion, fps, getAnimationConfig]);

//   return (
//     <PerformanceContext.Provider value={contextValue}>
//       {children}
//     </PerformanceContext.Provider>
//   );
// };

// export const usePerformance = () => {
//   const context = useContext(PerformanceContext);
//   if (!context) {
//     throw new Error('usePerformance must be used within PerformanceProvider');
//   }
//   return context;
// };

// Alternative: Lightweight version for better performance
export const LightweightPerformanceProvider = ({ children }) => {
  const [isLowPerformance, setIsLowPerformance] = useState(false);
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    // Check reduced motion preference
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReducedMotion(mediaQuery.matches);
    
    const handleChange = () => setReducedMotion(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);

    // Simple device-based performance detection
    const detectLowPerformance = () => {
      // Check for low-end devices
      const isLowEndDevice = 
        navigator.hardwareConcurrency <= 2 || // Less than 2 CPU cores
        navigator.deviceMemory <= 2 || // Less than 2GB RAM (if available)
        /Android.*Chrome\/[1-6][0-9]/.test(navigator.userAgent) || // Older Android Chrome
        /iPhone.*OS [1-9][0-4]_/.test(navigator.userAgent); // Older iOS

      if (isLowEndDevice) {
        setIsLowPerformance(true);
      }
    };

    detectLowPerformance();

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  const getAnimationConfig = useCallback((baseConfig = {}) => ({
    ...baseConfig,
    duration: reducedMotion ? 0.01 : isLowPerformance ? 0.15 : (baseConfig.duration || 0.3),
    ease: reducedMotion ? 'linear' : (baseConfig.ease || [0.25, 0.46, 0.45, 0.94])
  }), [reducedMotion, isLowPerformance]);

  const contextValue = React.useMemo(() => ({
    isLowPerformance,
    reducedMotion,
    getAnimationConfig
  }), [isLowPerformance, reducedMotion, getAnimationConfig]);

  return (
    <PerformanceContext.Provider value={contextValue}>
      {children}
    </PerformanceContext.Provider>
  );
};

// // Usage in your header component:
// export const useOptimizedAnimation = (baseConfig) => {
//   const { getAnimationConfig } = usePerformance();
//   return React.useMemo(() => getAnimationConfig(baseConfig), [getAnimationConfig, baseConfig]);
// };

